import { action, reatomBoolean } from '@reatom/framework'

import { authStateAtom } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'

import { logoutRequestAction } from '../../authenticate/atoms/auth-requests'

export const logoutAction = action(async (ctx) => {
  const { secureStorageService } = ctx.get(dependenciesAtom)
  authStateAtom.setInitial(ctx)
  localStorage.clear()
  secureStorageService.lock()
  logoutRequestAction(ctx).then(() => {
    location.reload()
  })
}, 'logoutAction')

export const logoutDialogAtom = reatomBoolean(false, 'logoutDialogAtom')
